import { render, staticRenderFns } from "./testresults.vue?vue&type=template&id=9488204a"
import script from "./testresults.vue?vue&type=script&lang=js"
export * from "./testresults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports